module.exports = __webpack_public_path__ + "img/im_octopus.47bd0574.jpg";